var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldForwardItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 9c0 2.29-.83 3.02-3.12 3.02v-1.64c0-3.12-1.39-4.51-4.51-4.51h-.983a.5.5 0 0 1-.475-.655C12.697 3.572 13.643 2.75 15 2.75h3.23c2.29 0 3.02.73 3.02 3.02V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.63 13.621c0 2.28-.73 3.01-3.01 3.01h-3.24c-2.28 0-3.01-.73-3.01-3.01v-3.24c0-2.28.73-3.01 3.01-3.01h3.24c2.28 0 3.01.73 3.01 3.01v3.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21.25H5.77c-2.29 0-3.02-.73-3.02-3.02V15c0-2.29.83-3.02 3.12-3.02v1.64c0 3.12 1.39 4.51 4.51 4.51h.983a.5.5 0 0 1 .476.655C11.303 20.43 10.357 21.25 9 21.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldForwardItem);
export default __webpack_public_path__ + "static/media/vuesax-bold-forward-item.be42781a3283e883d4e53eb74bbcf45a.svg";
export { ForwardRef as ReactComponent };